/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
// styles
import injectSheet from 'react-jss'
import styles from './groupname_styles'
import SectionGroupV2 from 'material/expandablesection/v2/sectiongroupv2/sectiongroupv2';
import { TextField } from '@insticator/insticator-ui/dist/material';
import Space from 'material/space/space'

/* ========== ~~~~~~~~~~ PRODUCT MANAGER: PRODUCT GROUP : GROUP NAME ~~~~~~~~~~ ========== */
const GroupName = injectSheet(styles)((props) => {

  const { label, isGroupNameExist, onChange } = props

  return (
    <SectionGroupV2 
      klass={`devices ${props.classes.devices}`} 
      title={'Group Name'} 
      description={'Enter a brief unique name to describe this group'}
    >
      <Space direction={'column'}>
        <TextField 
          type={`text`} 
          name={`productgrouplabel`} 
          value={label} 
          handleChange={e => { onChange('label', e.target.value)}} 
          label={''}
          placeholder={`Enter group name`} 
          maxLength={128}
          valid={label && !isGroupNameExist}
        />
      {!label && <span className='errormessage'>Group name is required</span>}
      {label && isGroupNameExist && <span className='errormessage'>Group name already exists.</span>}
      </Space>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default GroupName;